import { F } from '@/design/fonts';
import { RADIUS, T } from '@/design/tokens';
import type { CSSProperties } from 'react';

/**
 * StampChip — the Absolute Pinks brand mark, as the rubber-stamp "chip" used on
 * the landing-page ledger (mono, uppercase, pink, hairline border, slight tilt).
 * This is the logo; pink here is sanctioned brand use, not a status color.
 *
 * Mirrors the landing page's `.stamp-chip` treatment so the app and marketing
 * site read as one brand. The DOM text is "Absolute Pinks" (CSS uppercases it),
 * so it remains the accessible name.
 */
export function StampChip({
  size = 'md',
  style,
}: {
  /** `md` — header/nav scale; `lg` — sign-in / hero scale. */
  size?: 'md' | 'lg';
  style?: CSSProperties;
}) {
  const fontSize = size === 'lg' ? 15 : 12;
  const padding = size === 'lg' ? '5px 12px' : '3px 9px';
  return (
    <span
      style={{
        display: 'inline-block',
        fontFamily: F.mono,
        fontWeight: 600,
        fontSize,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        color: T.accent,
        border: `1px solid ${T.accent}`,
        borderRadius: RADIUS.sm,
        padding,
        transform: 'rotate(-4deg)',
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      Absolute Pinks
    </span>
  );
}
